const BaseService = require('@/services/BaseService')

const namespace = 'my-business/local-post'

const create = (type, options, cb, errorCb) => {
    BaseService.post(namespace + '/' + type, options, cb, errorCb)
}

const find = (id, options, cb, errorCb) => {
    BaseService.get(namespace + '/' + id, options, cb, errorCb)
}

const findAll = (options, cb, errorCb) => {
    BaseService.get(namespace, options, cb, errorCb)
}

const insights = (id, options, cb, errorCb) => {
    BaseService.get(namespace + '/insights/' + id, options, cb, errorCb)
}

const update = (id, options, cb, errorCb) => {
    BaseService.put(namespace + '/' + id, options, cb, errorCb)
}

const remove = (id, cb, errorCb) => {
    BaseService.remove(namespace + '/' + id, cb, errorCb)
}

export {
    create,
    find,
    findAll,
    insights,
    update,
    remove
}
